
import { useMemo } from "react";
import { Crown, CreditCard, User } from "lucide-react";
import { SINGLE_LETTER_DISPLAY } from "@/utils/publicPrices";

export interface PlanInfo {
  name: string;
  price: string;
  period: string;
  color: string;
  icon: React.ReactNode;
  description: string;
}

export function usePlanInfo() {
  const getPlanInfo = useMemo(() => {
    return (planType: string): PlanInfo => {
      switch (planType?.toLowerCase()) {
        case 'premium':
          return {
            name: 'Premium',
            price: 'R$ 29,90',
            period: 'por ano',
            color: 'bg-purple-100 text-purple-800',
            icon: <Crown className="h-4 w-4" />,
            description: 'Cartas ilimitadas com recursos premium'
          };
        case 'basic':
          return {
            name: 'Básico',
            price: SINGLE_LETTER_DISPLAY,
            period: 'por carta',
            color: 'bg-blue-100 text-blue-800',
            icon: <CreditCard className="h-4 w-4" />,
            description: 'Cartas individuais com recursos essenciais'
          };
        default:
          return {
            name: 'Gratuito',
            price: 'R$ 0,00',
            period: 'limitado',
            color: 'bg-gray-100 text-gray-800',
            icon: <User className="h-4 w-4" />,
            description: 'Plano básico com funcionalidades limitadas'
          };
      }
    };
  }, []);

  return { getPlanInfo };
}
